import { render, staticRenderFns } from "./AdminSystemHealth.vue?vue&type=template&id=629a4e03&scoped=true"
import script from "./AdminSystemHealth.vue?vue&type=script&lang=js"
export * from "./AdminSystemHealth.vue?vue&type=script&lang=js"
import style0 from "./AdminSystemHealth.vue?vue&type=style&index=0&id=629a4e03&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "629a4e03",
  null
  
)

export default component.exports